/**
 * Brand assets for the Lushin super-admin portal.
 *
 * The Sandler-Lushin lockup is served from `public/`, not imported through the
 * bundler, so the path is a root-relative URL rather than a module import. This
 * matches admin-portal, which references the same filename the same way.
 *
 * It is a WIDE horizontal lockup (432x50, ~8.6:1) — two wordmarks either side of
 * a divider rule. Size it by WIDTH and let the height follow; constraining the
 * height instead makes it wider than most containers expect.
 */
export const BRAND_LOGO_SRC = '/sandler-lushin-logo.svg';

/** Alt text for the lockup. Both wordmarks are part of the mark. */
export const BRAND_LOGO_ALT = 'Sandler Lushin';
